// Timing constants for various UI components

export const TIMING_CONSTANTS = {
  // Carousel auto-advance interval (in milliseconds)
  CAROUSEL_INTERVAL: 8000, // 8 seconds
  
  // Animation durations
  ANIMATION_DURATION: {
    FAST: 200,
    NORMAL: 300,
    SLOW: 500
  },
  
  // Debounce delays
  DEBOUNCE_DELAY: {
    SEARCH: 300, // 300ms delay for search input
    RESIZE: 150,
    SCROLL: 100
  },
  
  // Toast durations
  TOAST_DURATION: {
    SHORT: 3000,
    MEDIUM: 5000,
    LONG: 8000
  },
  
  // Cookie consent banner
  COOKIE_BANNER_INITIAL_DELAY: 2000, // 2 seconds
  COOKIE_BANNER_ANIMATION_DELAY: 300 // 300ms
} as const;